import { api } from 'data/api/api'

import { GetAvailableCarriersArgs, GetAvailableCarriersResp } from '../types/available-carrier'

export const getAvailableCarriers = ({
  shippingOrderId,
  selectedDeliveryType,
  shipmentId,
}: GetAvailableCarriersArgs) =>
  api.get<GetAvailableCarriersResp>(
    `shipping_orders/${shippingOrderId}/available_rates?delivery_type=${selectedDeliveryType}&shipment_id=${shipmentId}&exclude_current_rate=true`,
  )
